import { fx } from '../utilities/animation-preferences';

export default {
    // variables
    root: document.documentElement, // :root en css
    flashinfo: document.querySelector('.header-flashinfo'),

    // methods
    init() {
        if (!this.flashinfo) return;

        this.setRootFlashinfoHeight();
        this.flashinfo.addEventListener('selfClosed', this.handleSelfClosed.bind(this));

        // resize
        window.addEventListener('resizeEnd', this.handleResizeEnd.bind(this));
        window.addEventListener('load', this.handleLoad.bind(this));
    },
    handleLoad() {
        fx.to(this.flashinfo, { y: 0, duration: 0.5, delay: 1, ease: 'back.out(1.7)' });
    },
    handleSelfClosed() {
        this.root.style.setProperty('--flashinfo-height', '0px');
        this.flashinfo.remove();
    },
    handleResizeEnd() {
        this.setRootFlashinfoHeight();
    },
    setRootFlashinfoHeight() {
        // this.root.style.setProperty('--flashinfo-height', `${this.flashinfo.offsetHeight}px`);
    },
};
